<template>
  <v-dialog :model-value="modelValue" max-width="620" @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title>{{ form.id ? 'Каталог' : 'Новый каталог' }}</v-card-title>
      <v-card-text class="form-grid">
        <v-text-field v-model="form.title" label="Название" />
        <v-textarea v-model="form.description" label="Описание" rows="3" />
        <v-combobox v-model="form.tags" label="Тэги" multiple chips closable-chips />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="$emit('update:modelValue', false)">Отмена</v-btn>
        <v-btn color="primary" prepend-icon="mdi-content-save-outline" @click="$emit('save', form)">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { reactive, watch } from 'vue';
const props = defineProps({ modelValue: Boolean, catalog: Object });
defineEmits(['update:modelValue', 'save']);
const form = reactive({ id: null, title: '', description: '', tags: [] });
watch(() => props.catalog, (value) => Object.assign(form, { id: null, title: '', description: '', tags: [], ...(value || {}) }), { immediate: true });
</script>
